"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NModel = void 0;
var guid_typescript_1 = require("guid-typescript");
var NDefaultTypeCoder_1 = require("./NDefaultTypeCoder");
var object_1 = require("../utils/object");
var NModel = /** @class */ (function () {
    function NModel() {
        this._uniqueIdentifier = guid_typescript_1.Guid.create().toString();
    }
    NModel.universalModelType = function () {
        return 'io.avail.models.root.v1';
    };
    /**
     * Example: email => email_t
     */
    NModel.serializedTypeKeyForProperty = function (propName) {
        return "__" + propName + this.serializedTypeSuffix;
    };
    /**
     * Example: containingOrganizationIdentifiers => "__containingOrganizationIdentifiers_element_t"
     */
    NModel.serializedElementKeyForProperty = function (propName) {
        return "__" + propName + "_element" + this.serializedTypeSuffix;
    };
    /**
     * Create a new intance of `this` for deserializing.
     */
    NModel.create = function () {
        return Object.create(this.prototype);
    };
    Object.defineProperty(NModel.prototype, "uniqueIdentifier", {
        get: function () {
            return this._uniqueIdentifier;
        },
        set: function (value) {
            this._uniqueIdentifier = value;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Compares two models using the unique identifier. Assuming
     * the comparison is to be made based on only the uniqueIdentifier, since
     * that is what is generated when object is created.
     *
     * Deep object comparison can get weird with JS.
     */
    NModel.prototype.isEqualToModel = function (model) {
        return this._uniqueIdentifier === model.uniqueIdentifier;
    };
    /**
     * Recursively serialize properties through class getters
     * Returns ready object for JSON.stringify()
     */
    NModel.prototype.toJSON = function () {
        var _a, e_1, _b;
        var proto = Object.getPrototypeOf(this);
        var jsonObj = (_a = {},
            _a[NModel.serializedUmtKey] = proto.constructor.universalModelType(),
            _a);
        // iterate through whole prototype chain (all the way to Object)
        for (var o = this; o !== Object.prototype; o = Object.getPrototypeOf(o)) {
            try {
                for (var _c = (e_1 = void 0, __values(Object.getOwnPropertyNames(o))), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var name_1 = _d.value;
                    var descriptor = Object.getOwnPropertyDescriptor(o, name_1);
                    if (typeof descriptor.get === 'function') {
                        // instead of getting from `o`, get from `this`,
                        // since `o` is now the prototype of a superclass
                        var val = this[name_1];
                        var serializedVal = this.jsonReplacerForProperty(val);
                        var typeKey = NModel.serializedTypeKeyForProperty(name_1);
                        if (object_1.isIterable(val)) {
                            var elementKey = NModel.serializedElementKeyForProperty(name_1);
                            // Takeaway: if iterator has 0 items, the element
                            // type hint value will evaluate to ...unknown
                            var iterator = val.values();
                            var elementValue = NDefaultTypeCoder_1.NDefaultTypeCoder.typeCoding(iterator.next().value);
                            jsonObj[elementKey] = elementValue;
                        }
                        jsonObj[name_1] = serializedVal;
                        var typeHint = NDefaultTypeCoder_1.NDefaultTypeCoder.typeCoding(val);
                        // This magical pixie-dust is required for backwards compatibility with
                        // 10.0 and 10.1 and beyond.
                        if (typeKey.indexOf('transferIdentifier') !== -1 ||
                            (proto.constructor.universalModelType() ===
                                'io.avail.events.calls.telestrationStart.v2' &&
                                typeKey.indexOf('telestrationId') !== -1)) {
                            typeHint = NDefaultTypeCoder_1.typeMapping.uuid;
                        }
                        if (typeHint) {
                            jsonObj[typeKey] = typeHint;
                        }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        return jsonObj;
    };
    /**
     * Object serialization to JSON
     */
    NModel.prototype.jsonify = function () {
        return this.toJSON();
    };
    /**
     * replacer for special JSON stringified object properties
     * @param prop object property definition
     */
    NModel.prototype.jsonReplacerForProperty = function (prop) {
        var _this = this;
        if (prop instanceof guid_typescript_1.Guid) {
            // Guid's normal `toJSON` is a nested object. Boo! >:[
            return prop.toString();
        }
        else if (prop instanceof Date) {
            // epoch
            return prop.getTime();
        }
        else if (prop instanceof NModel) {
            // Account for any nested models
            return prop.toJSON();
        }
        else if (prop instanceof Set) {
            // There are no Sets in JSON so we need some need some form of mapping
            // Also, call this replacer on any nested model
            return __spread(prop).map(function (p) { return _this.jsonReplacerForProperty(p); });
        }
        return prop;
    };
    NModel.serializedUmtKey = '_umt';
    NModel.serializedTypeSuffix = '_t';
    return NModel;
}());
exports.NModel = NModel;
//# sourceMappingURL=NModel.js.map